import {brand, Branded, TypeOf} from 'io-ts';
import {NonEmptyString} from './NonEmptyString';

interface SwiftCodeBrand {
    readonly SwiftCode: unique symbol;
}

/**
 Condition to be a valid BIC:
 Bank Code: 4 letter code and only upper case alphabets are allowed.
 Country Code: 2 letter code and only upper case alphabets are allowed.
 Location Code: 2 letter code, either digits (0 to 9) or upper case alphabets are allowed.
 Branch Code: 3 letter optional code, either digits (0 to 9) or upper case alphabets are allowed.
 */
// Strict validation was disabled as part of https://jira.raison.digital/browse/RAISON-5136
// export const SwiftCode = brand(
//     NonEmptyString,
//     // eslint-disable-next-line security/detect-unsafe-regex
//     (n): n is Branded<NonEmptyString, SwiftCodeBrand> => /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(n),
//     'SwiftCode'
// );
export const SwiftCode = brand(
    NonEmptyString,
    (_n): _n is Branded<NonEmptyString, SwiftCodeBrand> => true,
    'SwiftCode'
);

export type SwiftCode = TypeOf<typeof SwiftCode>;
